import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  data: [],
  selectedPage: "",
};

const visitDetailsSlice = createSlice({
  name: "visitDetailsReducer",
  initialState,
  reducers: {
    setVisitPageData: (state, action) => {
      state.data = action.payload;
    },

    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },

    resetVisitDetails: (state, action) => {
      return initialState;
    },
  },
});

export const { setVisitPageData, setSelectedPage, resetVisitDetails } =
  visitDetailsSlice.actions;
export default visitDetailsSlice.reducer;
